import { SlidersOutlined } from "@ant-design/icons";
import { dynamicControllerCore } from "./core/dynamicController";
import { defineWidget } from "../widgetDefinition";
import { dynamicControllerSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { DynamicControllerComponentSpec } from "../Processing/types";
import { DynamicControllerWidget } from "../WidgetComponents/DynamicControllerWidget";
import { DynamicControllerConfigurator } from "../AddWidgetModal/DynamicControllerConfigurator";

export const dynamicControllerDefinition = defineWidget<DynamicControllerComponentSpec>({
  ...dynamicControllerCore,
  type: "slicer",
  slots: dynamicControllerSlots,
  // The controller owns no queryIds, so a copy needs no new identities.
  duplicate: NoDuplication,
  // The bulk apply must never overwrite a controller — it is the source other widgets follow.
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: ["display", "controls", "slicer_builder_misc"],
  contractHash: "1bv1cgts4pt",
  // The controller is the source others follow — none of its own sections can be bound (D9).
  dynamic: { bindableSections: [] },

  template: {
    label: "Slicer",
    description: "Date and subject pickers other widgets follow",
    icon: <SlidersOutlined />,
  },

  // Below ~2x3 the widget renders its chip face and the pickers open in a hover
  // popover, so even a 2x1 tile stays usable.
  defaultLayout: { w: 3, h: 3, minW: 2, minH: 1 },

  gridComponent: ({ id }) => <DynamicControllerWidget id={id} />,

  configurator: {
    modalTitle: "Slicer",
    wide: true,
    Component: DynamicControllerConfigurator as React.ComponentType<any>,
  },
});
